import { CondictionDataService } from './condiction-data.service';
import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { InformacionTablaMaestra } from '@app/shared';
import {
  Dropdown,
  Container,
  Legend,
  CondicionControl,
  BaseControl,
  Textbox,
  Custom,
  CondicionForma,
  TipoControl,
  Option,
  DateTimePicker,
  TablaMaestra
} from '@app/shared';

@Injectable()
export class CondictionsFormsService {
  masterTables: TablaMaestra[] = [];
  masterTablesField: InformacionTablaMaestra = new InformacionTablaMaestra();
  tablaMaestraSelectedId: any = null;
  tablaMaestraSelectedColumnId: any = null;
  valorCondicionMaestra: any = null;
  validarColumna = false;
  valorReferencia: any = null;
  columnaCondicionar: any = null;
  operarResultado = false;
  mantenerSesion  = false;

  constructor(
    private cfds: CondictionDataService
  ) { }

  /**
   * setea la data para el combo de lista de maestras para los controles
   *
   * @param {Array<TablaMaestra>} masterTables
   * @return {*}  {Array<any>}
   * @memberof CondictionsFormsService
   */
  setMasterTables(masterTables: Array<TablaMaestra>): Array<any> {
    const masterT: Array<any> = [];
    masterTables.forEach(mt => {
      masterT.push({
        key: mt.nombre,
        value: mt.id
      });
    });
    return masterT;
  }


  /**
  * setea la data para el combo de lista de las columnas maestras para los controles
  *
  * @param {Array<TablaMaestra>} masterTables
  * @return {*}  {Array<any>}
  * @memberof CondictionsFormsService
  */
  setMasterTablesFields(): Array<any> {
    const masterT: Array<any> = [];
    if (this.masterTablesField.estructura) {
      this.masterTablesField.estructura.forEach(mt => {
        masterT.push({
          key: mt.nombre,
          value: mt.id
        });
      });
    }
    return masterT;
  }

  /**
   * Crea el formulario de creacion o edicion de las condiciones
   *
   * @param {*} template
   * @param {*} options
   * @param {CondicionForma} [condition]
   * @param {TipoControl} [typeField]
   * @returns {BaseControl<any>[]}
   * @memberof CondictionsFormsService
   */
  getFormCondiction(
    template: any,
    options: any,
    condition?: CondicionForma
  ): BaseControl<any>[] {
    let sizeSies = 'col-md-4';
    let controlValor: BaseControl<any>;
    let controlValorCondiction: BaseControl<any>;
    let optionsCondicional: Array<Option> = [
      {key: 'Igual', value: 'Igual'},
      {key: 'Diferente', value: 'Diferente'},
      {key: 'Vacio', value: 'Vacio'},
    ];

    if (
      options['typeField'] &&
      (
        options['typeField'].nombre === 'number' ||
        options['typeField'].nombre === 'date-time-picker'
      )
    ) {
      optionsCondicional = [
        {key: 'Igual', value: 'Igual'},
        {key: 'Diferente', value: 'Diferente'},
        {key: 'Mayor a', value: 'Mayor a'},
        {key: 'Mayor o igual a', value: 'Mayor o igual a'},
        {key: 'Menor a', value: 'Menor a'},
        {key: 'Menor o igual a', value: 'Menor o igual a'},
        {key: 'Vacio', value: 'Vacio'},
      ];
    }

    controlValor = this.getControlValue(
      template,
      options,
      'typeField',
      'tipo',
      'optColumnMaster',
      'txtValor',
      condition
    );
    controlValorCondiction = this.getControlValueAssignation(
      template,
      options,
      'typeFieldCondiction',
      'tipoCondiction',
      'optColumnMasterCondiction',
      'txtValorAsignar',
      condition
    );
    if (controlValorCondiction) {
      controlValorCondiction.condictions = [
        {
          campoDepende: 'cboAction',
          siEs: 'Igual',
          valor: 'Asignar valor',
          accion: 'Mostrar'
        }
      ];
    }
    if (controlValor) {
      controlValor.condictions = [
        {
          campoDepende: 'cboSiEs',
          siEs: 'Diferente',
          valor: 'Vacio',
          accion: 'Mostrar'
        }
      ];
    }

    if (condition) {
      if (condition.siEs) {
        if (condition.siEs === 'Vacio') {
          sizeSies = 'col-md-6';
        } else if (options['typeField'] && options['typeField'].nombre === 'date-time-picker') {
          sizeSies = 'col-12';
        }
      }
    }

    const controls: BaseControl<any>[] = [
      new Legend({
        value: 'Depende de:',
        order: 1
      }),
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 2,
        controls: [
          new Custom({
            key: 'cboFormInit',
            label: 'Forma Inicia:',
            value: condition ? condition.formaInicia : null,
            template: template,
            options: options['formInitials'] ? options['formInitials'] : [],
            size: 'col-md-4',
            placeholder: 'Seleccionar la forma donde se encuentra el campo a validar',
            validations: {
              validators: [Validators.required]
            }
          }),
          new Custom({
            key: 'cboFormularioInit',
            label: 'Formulario Inicia:',
            value: condition ? condition.formularioInicia : null,
            template: template,
            options: options['formFormularios'] ? options['formFormularios'] : [],
            size: 'col-md-4',
            placeholder: 'Seleccionar el formulario donde se encuentra el campo a validar',
            validations: {
              validators: [Validators.required]
            }
          }),
          new Custom({
            key: 'cboFieldInit',
            label: 'Campo Inicia:',
            value: condition ? condition.campoInicia : null,
            template: template,
            options: options['fieldInit'] ? options['fieldInit'] : [],
            size: 'col-md-4',
            placeholder: 'Seleccionar el campo a validar',
            validations: {
              validators: [Validators.required]
            }
          }),
        ]
      }),
      new Legend({
        value: 'Condicion:',
        order: 3
      }),
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 4,
        controls: [
          new Dropdown({
            key: 'cboSiEs',
            label: 'Condicional a operar:',
            value: condition ? condition.siEs : '',
            options: optionsCondicional,
            size: sizeSies,
            placeholder: 'Seleccionar el condicional a operar',
            validations: {
              validators: [Validators.required]
            }
          }),
          controlValor,
          new Dropdown({
            key: 'cboAction',
            label: 'Accion:',
            options: [
              {key: 'Bloquear', value: 'Bloquear'},
              {key: 'Desbloquear', value: 'Desbloquear'},
              {key: 'Ocultar', value: 'Ocultar'},
              {key: 'Mostrar', value: 'Mostrar'},
              {key: 'Lectura', value: 'Lectura'},
              {key: 'Escritura', value: 'Escritura'},
              {key: 'Asignar valor', value: 'Asignar valor'},
              {key: 'Asignar valor maestra', value: 'Asignar valor maestra'},
            ],
            value: condition ? condition.accion : null,
            size: sizeSies,
            placeholder: 'Seleccione el operador para la condición siguiente',
            validations: {
              validators: [Validators.required]
            }
          }),
        ]
      }),
      new Legend({
        value: 'Afecta a:',
        order: 4
      }),
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 5,
        controls: [
          new Custom({
            key: 'cboFormularioCondiction',
            label: 'Formulario condicionado:',
            value: condition ? condition.formularioCondicionado : null,
            template: template,
            options: options['formCondictions'] ? options['formCondictions'] : [],
            size: 'col-md-4',
            placeholder: 'Seleccionar el formulario en el cual se realizara la accion',
            validations: {
              validators: [Validators.required]
            }
          }),
          new Custom({
            key: 'cboFieldCondiction',
            label: 'Campo condicionado:',
            template: template,
            options: options['fieldCondictions'] ? options['fieldCondictions'] : [],
            value: condition ? condition.campoCondicionado : null,
            size: 'col-md-4',
            placeholder: 'Seleccionar el campo en el cual se realizara la accion',
            validations: {
              validators: []
            }
          }),
          controlValorCondiction,
          new Custom({
            key: 'cboOperactorNext',
            label: 'Siguiente operador de condicion:',
            template: template,
            options: [
              {key: 'O', value: 'O'},
              {key: 'Y', value: 'Y'},
            ],
            value: condition ? condition.operadorCondicion : null,
            size: 'col-md-4',
            placeholder: 'Seleccione el operador para la condición siguiente',
            validations: {
              validators: []
            }
          }),
        ]
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea el formulario de creacion o edicion de las condiciones para los campos de los formularios
   *
   * @param {*} template
   * @param {*} options
   * @param {CondicionControl} [condition]
   * @param {TipoControl} [typeField]
   * @returns {BaseControl<any>[]}
   * @memberof CondictionsFormsService
   */
  getFormCondictionControl(
    template: any,
    options: any,
    condition?: CondicionControl
  ): BaseControl<any>[] {
    let sizeSies = 'col-md-4';
    let controlValor: BaseControl<any>;
    let controlValorCondiction: BaseControl<any>;
    let controlValorMaestra: BaseControl<any>;
    let optionsCondicional: Array<Option> = [
      {key: 'Igual', value: 'Igual'},
      {key: 'Diferente', value: 'Diferente'},
      {key: 'Vacio', value: 'Vacio'},
    ];

    if (
      options['typeField'] &&
      (
        options['typeField'].nombre === 'number' ||
        options['typeField'].nombre === 'date-time-picker'
      )
    ) {
      optionsCondicional = [
        {key: 'Igual', value: 'Igual'},
        {key: 'Diferente', value: 'Diferente'},
        {key: 'Mayor a', value: 'Mayor a'},
        {key: 'Mayor o igual a', value: 'Mayor o igual a'},
        {key: 'Menor a', value: 'Menor a'},
        {key: 'Menor o igual a', value: 'Menor o igual a'},
        {key: 'Vacio', value: 'Vacio'},
      ];
    }
    controlValor = this.getControlValue(
      template,
      options,
      'typeField',
      'tipo',
      'optColumnMaster',
      'txtValor',
      condition
    );
    controlValorCondiction = this.getControlValueAssignation(
      template,
      options,
      'typeFieldCondiction',
      'tipoCondiction',
      'optColumnMasterCondiction',
      'txtValorAsignar',
      condition
    );
    if(options["tipoCondiction"] && options["tipoCondiction"] == "calendar"){
      if (controlValorCondiction) {
        controlValorCondiction.order = 5;
      }
    }else{
      if (controlValorCondiction) {
        controlValorCondiction.order = 5;
        controlValorCondiction.condictions = [
          {
            campoDepende: 'cboAction',
            siEs: 'Igual',
            valor: 'Asignar valor',
            accion: 'Mostrar'
          }
        ];
      }
    }
    controlValorMaestra = this.getControlValueAssignation(
      template,
      options,
      'typeFieldCondiction',
      'tipoCondiction',
      'optColumnMasterCondiction',
      'txtValorMaestra',
      condition
    );
    if (controlValorMaestra) {
      controlValorMaestra.order = 5;
      controlValorMaestra.condictions = [
        {
          campoDepende: 'cboAction',
          siEs: 'Igual',
          valor: 'Asignar valor maestra',
          accion: 'Mostrar'
        }
      ];
    }
    if (controlValor) {
      controlValor.condictions = [
        {
          campoDepende: 'cboSiEs',
          siEs: 'Diferente',
          valor: 'Vacio',
          accion: 'Mostrar'
        }
      ];
    }
    if (condition) {
      if (condition.siEs) {
        if (condition.siEs === 'Vacio') {
          sizeSies = 'col-md-6';
        } else if (options['typeField'] && options['typeField'].nombre === 'date-time-picker') {
          sizeSies = 'col-12';
        }
      }
    }
    if(options["tipoCondiction"] && options["tipoCondiction"] == "calendar"){
      const controls: BaseControl<any>[] = [
        new Legend({
          value: 'Depende de:',
          order: 1
        }),
        new Container({
          class: 'form-row form-check form-check-inline col-12',
          order: 2,
          controls: [
            new Custom({
              key: 'cboFieldInit',
              label: 'Campo Depende:',
              value: condition ? condition.campoDepende : null,
              template: template,
              options: options['fieldInit'] ? options['fieldInit'] : [],
              size: 'col-md-12',
              placeholder: 'Seleccionar el campo del cual depende la validacion',
              validations: {
                validators: [Validators.required]
              }
            }),
          ]
        }),
        new Legend({
          value: 'Condicion:',
          order: 3
        }),
        new Container({
          class: 'form-row form-check form-check-inline col-12',
          order: 4,
          controls: [
            new Dropdown({
              key: 'cboSiEs',
              label: 'Condicional a operar:',
              value: condition ? condition.siEs : '',
              options: optionsCondicional,
              size: sizeSies,
              placeholder: 'Seleccionar el condicional a operar',
              validations: {
                validators: [Validators.required]
              }
            }),
            controlValor,
            new Dropdown({
              key: 'cboAction',
              label: 'Accion:',
              options: [
                {key: 'Bloquear', value: 'Bloquear'},
                {key: 'Desbloquear', value: 'Desbloquear'},
                {key: 'Ocultar', value: 'Ocultar'},
                {key: 'Mostrar', value: 'Mostrar'},
                {key: 'Lectura', value: 'Lectura'},
                {key: 'Escritura', value: 'Escritura'},
                {key: 'Asignar valor', value: 'Asignar valor'},
              ],
              value: condition ? condition.accion : null,
              size: sizeSies,
              placeholder: 'Seleccione el operador para la condición siguiente',
              validations: {
                validators: [Validators.required]
              }
            }),
          ]
        }),
        controlValorCondiction,
        new Custom({
          key: 'cboOperactorNext',
          label: 'Siguiente operador de condicion:',
          order: 6,
          template: template,
          options: [
            {key: 'O', value: 'O'},
            {key: 'Y', value: 'Y'},
          ],
          value: condition ? condition.operadorCondicion : null,
          placeholder: 'Seleccione el operador para la condición siguiente',
          validations: {
            validators: []
          }
        }),
      ];
      return controls.sort((a, b) => a.order - b.order);
    }else{
      const controls: BaseControl<any>[] = [
        new Legend({
          value: 'Depende de:',
          order: 1
        }),
        new Container({
          class: 'form-row form-check form-check-inline col-12',
          order: 2,
          controls: [
            new Custom({
              key: 'cboFieldInit',
              label: 'Campo Depende:',
              value: condition ? condition.campoDepende : null,
              template: template,
              options: options['fieldInit'] ? options['fieldInit'] : [],
              size: 'col-md-12',
              placeholder: 'Seleccionar el campo del cual depende la validacion',
              validations: {
                validators: [Validators.required]
              }
            }),
          ]
        }),
        new Legend({
          value: 'Condicion:',
          order: 3
        }),
        new Container({
          class: 'form-row form-check form-check-inline col-12',
          order: 4,
          controls: [
            new Dropdown({
              key: 'cboSiEs',
              label: 'Condicional a operar:',
              value: condition ? condition.siEs : '',
              options: optionsCondicional,
              size: sizeSies,
              placeholder: 'Seleccionar el condicional a operar',
              validations: {
                validators: [Validators.required]
              }
            }),
            controlValor,
            new Dropdown({
              key: 'cboAction',
              label: 'Accion:',
              options: [
                {key: 'Bloquear', value: 'Bloquear'},
                {key: 'Desbloquear', value: 'Desbloquear'},
                {key: 'Ocultar', value: 'Ocultar'},
                {key: 'Mostrar', value: 'Mostrar'},
                {key: 'Lectura', value: 'Lectura'},
                {key: 'Escritura', value: 'Escritura'},
                {key: 'Asignar valor', value: 'Asignar valor'},
                {key: 'Asignar valor maestra', value: 'Asignar valor maestra'},
              ],
              value: condition ? condition.accion : null,
              size: sizeSies,
              placeholder: 'Seleccione el operador para la condición siguiente',
              validations: {
                validators: [Validators.required]
              }
            }),
          ]
        }),
        controlValorCondiction,
        controlValorMaestra,
        new Custom({
          key: 'cboOperactorNext',
          label: 'Siguiente operador de condicion:',
          order: 6,
          template: template,
          options: [
            {key: 'O', value: 'O'},
            {key: 'Y', value: 'Y'},
          ],
          value: condition ? condition.operadorCondicion : null,
          placeholder: 'Seleccione el operador para la condición siguiente',
          validations: {
            validators: []
          }
        }),
      ];
      return controls.sort((a, b) => a.order - b.order);
    }
   

   
  }

  /**
   * Retorna el control del valor para validar o asignar
   *
   * @private
   * @param {*} template
   * @param {*} options
   * @param {string} type
   * @param {string} typeCalendar
   * @param {string} typeColumns
   * @param {string} key
   * @param {(CondicionControl | CondicionForma)} [condition]
   * @returns {BaseControl<any>}
   * @memberof CondictionsFormsService
   */
  private getControlValue(
    template: any,
    options: any,
    type: string,
    typeCalendar: string,
    typeColumns: string,
    key: string,
    condition?: CondicionControl | CondicionForma,
  ): BaseControl<any> {
    let controlValor: BaseControl<any>;
    let sizeSies = 'col-md-4';
    if (condition) {
      if (condition.siEs) {
        controlValor = this.getFormValor(
          condition.siEs,
          type === 'typeField' ? condition.valor : condition.valorAsignar,
          template,
          options,
          options[type],
          typeCalendar,
          typeColumns,
          key,
          condition
        );
        if (condition.siEs !== 'Vacio') {
          if (options[type] && options[type].nombre === 'date-time-picker') {
            if (controlValor['controls'] && controlValor['controls'].length) {
              controlValor['controls'][1]['value'] = condition ? condition.fechaActual ? true : false : false;
            }
          }
        }
      }
    }

    if (!controlValor) {
      if (options[type] && options[type].nombre === 'checkbox') {
        controlValor = new Dropdown({
          key: key,
          label: 'Valor:',
          value: condition ? type === 'typeField' ? condition.valor : condition.valorAsignar : null,
          options: [
            {key: 'true', value: 'Seleccionado'},
            {key: 'false', value: 'No seleccionado'},
          ],
          size: sizeSies,
          placeholder: 'Ingresar el alias de la asociacion que contiene la forma',
          validations: {
            validators: [Validators.required]
          }
        });
      } else if (
        options[type] &&
        options[type].nombre === 'ngSelect' &&
        options[typeColumns] &&
        options[typeColumns].length
      ) {
        controlValor = new Custom({
          key: key,
          label: 'Valor:',
          template: template,
          value: condition ? type === 'typeField' ? condition.valor : condition.valorAsignar : null,
          options: options[typeColumns] ? options[typeColumns] : [],
          size: sizeSies,
          placeholder: 'Seleccione el valor',
          validations: {
            validators: [Validators.required]
          }
        });
      } else if (options[type] && options[type].nombre === 'date-time-picker') {
        controlValor = new Container(
          {
            class: 'form-row form-check form-check-inline col-12',
            controls: [
              new DateTimePicker({
                key: 'txtValorAsignar',
                label: 'Valor:',
                value: condition ?
                        type === 'typeField' ?
                          condition.valor ?
                            new Date(condition.valor)
                          : null
                        : condition.valorAsignar ?
                          new Date(condition.valorAsignar)
                        : null
                       : null,
                size: 'col-md-10',
                pickerType: options[typeCalendar] ? options[typeCalendar] : null,
                placeholder: 'Seleccione el valor',
                validations: {
                  validators: [Validators.required]
                },
                condictions: [
                  {
                    campoDepende: 'cboAction',
                    siEs: 'Igual',
                    valor: 'Asignar valor',
                    accion: 'Mostrar',
                  },
                  {
                    campoDepende: 'chFechaActual',
                    siEs: 'Igual',
                    valor: 'true',
                    accion: 'Bloquear',
                  }
                ],
              }),
              new Textbox({
                key: 'chFechaActual',
                type: 'checkbox',
                value: condition ? condition.fechaActual ? condition.fechaActual : false : false,
                label: 'Fecha actual',
                size: 'col-md-2',
                condictions: [
                  {
                    campoDepende: 'cboAction',
                    siEs: 'Igual',
                    valor: 'Asignar valor',
                    accion: 'Mostrar',
                  }
                 ]
              }),
            ]
          }
        );
        sizeSies = 'col-12';
      }
       else if (key === 'txtValorMaestra') {
        controlValor = new Container(
          {
            class: 'form-row form-check form-check-inline col-12',
            controls: [
              new Custom({
                key: 'cbSelectMaestra',
                label: 'Maestra:',
                template: template,
                value: this.tablaMaestraSelectedId,
                options: this.setMasterTables(this.masterTables),
                size: sizeSies,
                placeholder: 'Seleccione el valor',
                validations: {
                  validators: [Validators.required]
                },
                condictions: [
                  {
                    campoDepende: 'cboAction',
                      siEs: 'Igual',
                      valor: 'Asignar valor maestra',
                      accion: 'Mostrar'
                  }
                ],
              }),

              new Custom({
                key: 'cbColumnaMaestra',
                label: 'Colmna maestra:',
                template: template,
                value: this.tablaMaestraSelectedColumnId,
                options: this.setMasterTablesFields(),
                size: sizeSies,
                placeholder: 'Seleccione el valor',
                validations: {
                  validators: [Validators.required]
                },
                condictions: [
                  {
                    campoDepende: 'cboAction',
                      siEs: 'Igual',
                      valor: 'Asignar valor maestra',
                      accion: 'Mostrar'
                  }
                ],
              }),
              new Textbox({
                key: 'chValidarColumna',
                type: 'checkbox',
                value: this.validarColumna,
                label: 'Validar columna',
                size: 'col-md-2',
                condictions: [
                  {
                    campoDepende: 'cboAction',
                      siEs: 'Igual',
                      valor: 'Asignar valor maestra',
                      accion: 'Mostrar'
                  }
                ],
              }),
              new Custom({
                key: 'cbColumnaCondicionar',
                label: 'Columna a condicionar:',
                template: template,
                value: this.columnaCondicionar,
                options: this.setMasterTablesFields(),
                size: sizeSies,
                placeholder: 'Seleccione el valor',
                validations: {
                  validators: [Validators.required]
                },
                condictions: [
                  {
                    campoDepende: 'chValidarColumna',
                    siEs: 'Igual',
                    valor: 'true',
                    accion: 'Mostrar'
                  }
                ],
              }),
              new Textbox({
                key: 'txtValorMaestra',
                label: 'Valor maestra:',
                value: this.valorCondicionMaestra,
                size: 'col-md-4',
                placeholder: 'Valor maestra',
                validations: {
                  validators: [Validators.required]
                },
                condictions: [
                  {
                    campoDepende: 'chValidarColumna',
                    siEs: 'Igual',
                    valor: 'true',
                    accion: 'Mostrar'
                  }
                ],
              }),
              new Custom({
                key: 'cbValorReferencia',
                label: 'Valor de referencia:',
                template: template,
                value: this.valorReferencia,
                options: this.setMasterTablesFields(),
                size: sizeSies,
                placeholder: 'Seleccione el valor',
                condictions: [
                  {
                    campoDepende: 'chValidarColumna',
                    siEs: 'Igual',
                    valor: 'true',
                    accion: 'Mostrar'
                  }
                ],
              }),
              new Textbox({
                key: 'chOperarResultado',
                type: 'checkbox',
                value: this.operarResultado,
                label: 'Operar resultado',
                size: 'col-md-2',
                condictions: [
                  {
                    campoDepende: 'chValidarColumna',
                    siEs: 'Igual',
                    valor: 'true',
                    accion: 'Mostrar'
                  }
                ],
              }),
              new Textbox({
                key: 'chMantenerSesion',
                type: 'checkbox',
                value: this.mantenerSesion,
                label: 'Mantener resultado en sesión',
                size: 'col-md-2',
                condictions: [
                  {
                    campoDepende: 'cboAction',
                      siEs: 'Igual',
                      valor: 'Asignar valor maestra',
                      accion: 'Mostrar'
                  }
                ],
              }),
            ]
          }
        );

      } else {
        controlValor = new Textbox({
          key: key,
          label: 'Valor:',
          value: condition ? condition.valor : null,
          size: sizeSies,
          placeholder: 'Ingresar el alias de la asociacion que contiene la forma',
          validations: {
            validators: [Validators.required]
          }
        });
      }
    }
    return controlValor;
  }


  
  /**
   * Retorna el control del valor para validar o asignar valor del control para condiciones o condiciones maestros
   *
   * @private
   * @param {*} template
   * @param {*} options
   * @param {string} type
   * @param {string} typeCalendar
   * @param {string} typeColumns
   * @param {string} key
   * @param {(CondicionControl | CondicionForma)} [condition]
   * @returns {BaseControl<any>}
   * @memberof CondictionsFormsService
   */
   private getControlValueAssignation(
    template: any,
    options: any,
    type: string,
    typeCalendar: string,
    typeColumns: string,
    key: string,
    condition?: CondicionControl | CondicionForma,
  ): BaseControl<any> {
    let controlValor: BaseControl<any>;
    let sizeSies = 'col-md-4';
    
    if (options[type] && options[type].nombre === 'checkbox') {
        controlValor = new Dropdown({
          key: key,
          label: 'Valor:',
          value: condition ? type === 'typeField' ? condition.valor : condition.valorAsignar : null,
          options: [
            {key: 'true', value: 'Seleccionado'},
            {key: 'false', value: 'No seleccionado'},
          ],
          size: sizeSies,
          placeholder: 'Ingresar el alias de la asociacion que contiene la forma',
          validations: {
            validators: [Validators.required]
          }
        });
    } else if (
        options[type] &&
        options[type].nombre === 'ngSelect' &&
        options[typeColumns] &&
        options[typeColumns].length
      ) {
        controlValor = new Custom({
          key: key,
          label: 'Valor:',
          template: template,
          value: condition ? type === 'typeField' ? condition.valor : condition.valorAsignar : null,
          options: options[typeColumns] ? options[typeColumns] : [],
          size: sizeSies,
          placeholder: 'Seleccione el valor',
          validations: {
            validators: [Validators.required]
          }
        });
    } else if (options[type] && options[type].nombre === 'date-time-picker') {
        controlValor = new Container(
          {
            class: 'form-row form-check form-check-inline col-12',
            controls: [
              new DateTimePicker({
                key: 'txtValorAsignar',
                label: 'Valor:',
                value: condition ?
                        type === 'typeField' ?
                          condition.valor ?
                            new Date(condition.valor)
                          : null
                        : condition.valorAsignar ?
                          new Date(condition.valorAsignar)
                        : null
                       : null,
                size: 'col-md-10',
                pickerType: options[typeCalendar] ? options[typeCalendar] : null,
                placeholder: 'Seleccione el valor',
                validations: {
                  validators: [Validators.required]
                },
                condictions: [
                  {
                    campoDepende: 'cboAction',
                    siEs: 'Igual',
                    valor: 'Asignar valor',
                    accion: 'Mostrar',
                  },
                  {
                    campoDepende: 'txtValorAsignar_chFechaActual',
                    siEs: 'Igual',
                    valor: 'true',
                    accion: 'Bloquear',
                  }
                ],
              }),
              new Textbox({
                key: 'txtValorAsignar_chFechaActual',
                type: 'checkbox',
                value: condition ? condition.fechaActualAsignar ? condition.fechaActualAsignar : false : false,
                label: 'Fecha actual',
                size: 'col-md-2',
                condictions: [
                  {
                    campoDepende: 'cboAction',
                    siEs: 'Igual',
                    valor: 'Asignar valor',
                    accion: 'Mostrar',
                  }
                 ]
              }),
            ]
          }
        );
        sizeSies = 'col-12';
    }
    else if (key === 'txtValorMaestra') {
        controlValor = new Container(
          {
            class: 'form-row form-check form-check-inline col-12',
            controls: [
              new Custom({
                key: 'cbSelectMaestra',
                label: 'Maestra:',
                template: template,
                value: this.tablaMaestraSelectedId,
                options: this.setMasterTables(this.masterTables),
                size: sizeSies,
                placeholder: 'Seleccione el valor',
                validations: {
                  validators: [Validators.required]
                },
                condictions: [
                  {
                    campoDepende: 'cboAction',
                      siEs: 'Igual',
                      valor: 'Asignar valor maestra',
                      accion: 'Mostrar'
                  }
                ],
              }),

              new Custom({
                key: 'cbColumnaMaestra',
                label: 'Colmna maestra:',
                template: template,
                value: this.tablaMaestraSelectedColumnId,
                options: this.setMasterTablesFields(),
                size: sizeSies,
                placeholder: 'Seleccione el valor',
                validations: {
                  validators: [Validators.required]
                },
                condictions: [
                  {
                    campoDepende: 'cboAction',
                      siEs: 'Igual',
                      valor: 'Asignar valor maestra',
                      accion: 'Mostrar'
                  }
                ],
              }),
              new Textbox({
                key: 'chValidarColumna',
                type: 'checkbox',
                value: this.validarColumna,
                label: 'Validar columna',
                size: 'col-md-2',
                condictions: [
                  {
                    campoDepende: 'cboAction',
                      siEs: 'Igual',
                      valor: 'Asignar valor maestra',
                      accion: 'Mostrar'
                  }
                ],
              }),
              new Custom({
                key: 'cbColumnaCondicionar',
                label: 'Columna a condicionar:',
                template: template,
                value: this.columnaCondicionar,
                options: this.setMasterTablesFields(),
                size: sizeSies,
                placeholder: 'Seleccione el valor',
                validations: {
                  validators: [Validators.required]
                },
                condictions: [
                  {
                    campoDepende: 'chValidarColumna',
                    siEs: 'Igual',
                    valor: 'true',
                    accion: 'Mostrar'
                  }
                ],
              }),
              new Textbox({
                key: 'txtValorMaestra',
                label: 'Valor maestra:',
                value: this.valorCondicionMaestra,
                size: 'col-md-4',
                placeholder: 'Valor maestra',
                validations: {
                  validators: [Validators.required]
                },
                condictions: [
                  {
                    campoDepende: 'chValidarColumna',
                    siEs: 'Igual',
                    valor: 'true',
                    accion: 'Mostrar'
                  }
                ],
              }),
              new Custom({
                key: 'cbValorReferencia',
                label: 'Valor de referencia:',
                template: template,
                value: this.valorReferencia,
                options: this.setMasterTablesFields(),
                size: sizeSies,
                placeholder: 'Seleccione el valor',
                condictions: [
                  {
                    campoDepende: 'chValidarColumna',
                    siEs: 'Igual',
                    valor: 'true',
                    accion: 'Mostrar'
                  }
                ],
              }),
              new Textbox({
                key: 'chOperarResultado',
                type: 'checkbox',
                value: this.operarResultado,
                label: 'Operar resultado',
                size: 'col-md-2',
                condictions: [
                  {
                    campoDepende: 'chValidarColumna',
                    siEs: 'Igual',
                    valor: 'true',
                    accion: 'Mostrar'
                  }
                ],
              }),
              new Textbox({
                key: 'chMantenerSesion',
                type: 'checkbox',
                value: this.mantenerSesion,
                label: 'Mantener resultado en sesión',
                size: 'col-md-2',
                condictions: [
                  {
                    campoDepende: 'cboAction',
                      siEs: 'Igual',
                      valor: 'Asignar valor maestra',
                      accion: 'Mostrar'
                  }
                ],
              }),
            ]
          }
        );

    } else {
        controlValor = new Textbox({
          key: key,
          label: 'Valor:',
          value: condition ? condition.valorAsignar : null,
          size: sizeSies,
          placeholder: 'Ingresar el alias de la asociacion que contiene la forma',
          validations: {
            validators: [Validators.required]
          }
        });
    }
    return controlValor;
  }

  /**
   *  Retorna el control de valor dependiendo de lo seleccionado en el control de si es
   *
   * @private
   * @param {string} operactorCondiction
   * @param {*} value
   * @param {*} template
   * @param {*} options
   * @param {TipoControl} typeField
   * @returns {BaseControl<any>}
   * @memberof CondictionsFormsService
   */
  private getFormValor(
    operactorCondiction: string,
    value: any,
    template: any,
    options: any,
    typeField: TipoControl,
    typeCalendar: string,
    typeColumns: string,
    key: string,
    condition?: CondicionControl | CondicionForma,
  ): BaseControl<any> {
    switch (operactorCondiction) {
      case 'Vacio':
        return new Textbox({
          key: key,
          label: 'Valor:',
          value: value,
          hidden: true,
          validations: {
            validators: []
          }
        });
      default:
        if (typeField && typeField.nombre === 'checkbox') {
          return new Dropdown({
            key: key,
            label: 'Valor:',
            value: value,
            options: [
              {key: 'true', value: 'Seleccionado'},
              {key: 'false', value: 'No seleccionado'},
            ],
            size: 'col-md-4',
            placeholder: 'Seleccione el estado del checkbox',
            validations: {
              validators: [Validators.required]
            }
          });
        } else if (typeField && typeField.nombre === 'date-time-picker') {

          return new Container(
            {
              class: 'form-row form-check form-check-inline col-12',
              controls: [
                new DateTimePicker({
                  key: key,
                  label: 'Valor:',
                  value: value ? new Date(value) : null,
                  size: 'col-md-10',
                  pickerType: options[typeCalendar] ? options[typeCalendar] : null,
                  placeholder: 'Seleccione el valor',
                  validations: {
                    validators: [Validators.required]
                  },
                  condictions: [
                    {
                      campoDepende: key + '_chFechaActual',
                      siEs: 'Igual',
                      valor: 'true',
                      accion: 'Bloquear',
                    }
                  ],
                }),
                new Textbox({
                  key: key + '_chFechaActual',
                  type: 'checkbox',
                  value: condition ? condition.fechaActual ? condition.fechaActual : false : false,
                  label: 'Fecha actual',
                  size: 'col-md-2',
                }),
              ]
            }
          );
        } else if (
          typeField &&
          typeField.nombre === 'ngSelect' &&
          options[typeColumns] &&
          options[typeColumns].length
        ) {
          return new Custom({
            key: key,
            label: 'Valor:',
            template: template,
            value: value,
            options: options[typeColumns] ? options[typeColumns] : [],
            size: 'col-md-4',
            placeholder: 'Seleccione el valor',
            validations: {
              validators: [Validators.required]
            }
          });
        } else if (key === 'txtValorMaestra') {

          return new Container(
            {
              class: 'form-row form-check form-check-inline col-12',
              controls: [
                new Custom({
                  key: 'cbSelectMaestra',
                  label: 'Maestra:',
                  template: template,
                  value: this.tablaMaestraSelectedId,
                  options: this.setMasterTables(this.masterTables),
                  size: 'col-md-4',
                  placeholder: 'Seleccione el valor',
                  validations: {
                    validators: [Validators.required]
                  },
                  condictions: [
                    {
                      campoDepende: 'cboAction',
                      siEs: 'Igual',
                      valor: 'Asignar valor maestra',
                      accion: 'Mostrar'
                    }
                  ],
                }),
  
                new Custom({
                  key: 'cbColumnaMaestra',
                  label: 'Colmna maestra:',
                  template: template,
                  value: this.tablaMaestraSelectedColumnId,
                  options: this.setMasterTablesFields(),
                  size: 'col-md-4',
                  placeholder: 'Seleccione el valor',
                  validations: {
                    validators: [Validators.required]
                  },
                  condictions: [
                    {
                      campoDepende: 'cboAction',
                        siEs: 'Igual',
                        valor: 'Asignar valor maestra',
                        accion: 'Mostrar'
                    }
                  ],
                }),
                new Textbox({
                  key: 'chValidarColumna',
                  type: 'checkbox',
                  value: this.validarColumna,
                  label: 'Validar columna',
                  size: 'col-md-2',
                  condictions: [
                    {
                      campoDepende: 'cboAction',
                        siEs: 'Igual',
                        valor: 'Asignar valor maestra',
                        accion: 'Mostrar'
                    }
                  ],
                }),
                new Custom({
                  key: 'cbColumnaCondicionar',
                  label: 'Columna a condicionar:',
                  template: template,
                  value: this.columnaCondicionar,
                  options:  this.setMasterTablesFields(),
                  size: 'col-md-4',
                  placeholder: 'Seleccione el valor',
                  validations: {
                    validators: [Validators.required]
                  },
                  condictions: [
                    {
                      campoDepende: 'chValidarColumna',
                      siEs: 'Igual',
                      valor: 'true',
                      accion: 'Mostrar'
                    }
                  ],
                }),
                new Textbox({
                  key: 'txtValorMaestra',
                  label: 'Valor maestra:',
                  value: this.valorCondicionMaestra,
                  size: 'col-md-4',
                  placeholder: 'Valor maestra',
                  validations: {
                    validators: [Validators.required]
                  },
                  condictions: [
                    {
                      campoDepende: 'chValidarColumna',
                      siEs: 'Igual',
                      valor: 'true',
                      accion: 'Mostrar'
                    }
                  ],
                }),
                new Custom({
                  key: 'cbValorReferencia',
                  label: 'Valor de referencia:',
                  template: template,
                  value: this.valorReferencia,
                  options:  this.setMasterTablesFields(),
                  size: 'col-md-4',
                  placeholder: 'Seleccione el valor',
                  condictions: [
                    {
                      campoDepende: 'chValidarColumna',
                      siEs: 'Igual',
                      valor: 'true',
                      accion: 'Mostrar'
                    }
                  ],
                }),
                new Textbox({
                  key: 'chOperarResultado',
                  type: 'checkbox',
                  value: this.operarResultado,
                  label: 'Operar resultado',
                  size: 'col-md-2',
                  condictions: [
                    {
                      campoDepende: 'chValidarColumna',
                      siEs: 'Igual',
                      valor: 'true',
                      accion: 'Mostrar'
                    }
                  ],
                }),
                new Textbox({
                  key: 'chMantenerSesion',
                  type: 'checkbox',
                  value: this.mantenerSesion,
                  label: 'Mantener resultado en sesión',
                  size: 'col-md-2',
                  condictions: [
                    {
                      campoDepende: 'cboAction',
                        siEs: 'Igual',
                        valor: 'Asignar valor maestra',
                        accion: 'Mostrar'
                    }
                  ],
                }),
              ]
            }
          );
  
        } else {
          return new Textbox({
            key: key,
            label: 'Valor:',
            value: value,
            size: 'col-md-4',
            placeholder: 'Ingresar el valor',
            validations: {
              validators: [Validators.required]
            }
          });
        }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/conditions/shared/condition.forms.service.ts